import { useEffect } from 'react';

import cn from 'classnames/bind';
import { useToggleState } from 'hooks';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import s from './RouteProgressBar.module.scss';

const cx = cn.bind(s);

const ProgressBar = ({
  children, className, ...attrs
}) => {
  const router = useRouter();
  const { isActive, open: setActive, close: setNotActive } = useToggleState();
  useEffect(() => {
    const onChangeStart = () => setActive();
    const onChangeComplete = () => setNotActive();
    router.events.on('routeChangeStart', onChangeStart);
    router.events.on('routeChangeComplete', onChangeComplete);
    router.events.on('routeChangeError', onChangeComplete);
    return () => {
      router.events.off('routeChangeStart', onChangeStart);
      router.events.off('routeChangeComplete', onChangeComplete);
      router.events.off('routeChangeError', onChangeComplete);
    };
  }, [router, setActive, setNotActive]);
  return isActive && (
    <div className={cx(className, 'progress')} {...attrs} />
  );
};

ProgressBar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ProgressBar;
